import { gql } from "@apollo/client";

export const GET_MONTLY_INVENTORY_REPORT_III = gql`
  query GetMonthlyInventoryReportIII(
    $warehouseIds: [ID]
    $groupIds: [ID]
    $sectionIds: [ID]
    $levelSectionIds: [ID]
    $sizeIds: [ID]
    $from: Date
    $materialIds: [ID]
    $to: Date
    $isHaveStock: Boolean
  ) {
    getMonthlyInventoryReportIII(
      warehouseIds: $warehouseIds
      groupIds: $groupIds
      sectionIds: $sectionIds
      levelSectionIds: $levelSectionIds
      sizeIds: $sizeIds
      from: $from
      materialIds: $materialIds
      to: $to
      isHaveStock: $isHaveStock
    ) {
      _id
      groupEnName
      groupKhName
      beginning {
        costPerUnit
        units
        cost
      }
      purchase {
        costPerUnit
        units
        cost
      }
      issues {
        cost
        units
      }
      return {
        cost
        units
      }
      ending {
        units
        cost
      }
      materials {
        _id
        materialEnName
        materialKhName
        smallUnitId {
          unitKhName
          unitEnName
        }
        sizeId {
          sizeKhName
          sizeEnName
        }
        beginning {
          costPerUnit
          units
          cost
        }
        purchase {
          costPerUnit
          units
          cost
        }
        averageCost
        issues {
          units
          cost
        }
        return {
          units
          cost
        }
        ending {
          units
          cost
        }
      }
    }
  }
`;

export const GET_MONTLY_MATERIAL_USING_REPORT = gql`
  query GetMonthlyMaterialUsingReport(
    $warehouseIds: [ID]
    $categoryIds: [ID]
    $sectionIds: [ID]
    $levelSectionIds: [ID]
    $sizeIds: [ID]
    $materialIds: [ID]
    $from: Date
    $to: Date
    $isHaveStock: Boolean
  ) {
    getMonthlyMaterialUsingReport(
      warehouseIds: $warehouseIds
      categoryIds: $categoryIds
      sectionIds: $sectionIds
      levelSectionIds: $levelSectionIds
      sizeIds: $sizeIds
      materialIds: $materialIds
      from: $from
      to: $to
      isHaveStock: $isHaveStock
    ) {
      _id
      groupEnName
      groupKhName
      beginning {
        costPerUnit
        units
        cost
      }
      purchase {
        costPerUnit
        units
        cost
      }
      issues {
        cost
        units
      }
      return {
        cost
        units
      }
      ending {
        units
        cost
      }
      materials {
        _id
        materialEnName
        materialKhName
        smallUnitId {
          unitKhName
          unitEnName
        }
        sizeId {
          sizeKhName
          sizeEnName
        }
        beginning {
          costPerUnit
          units
          cost
        }
        purchase {
          costPerUnit
          units
          cost
        }
        averageCost
        issues {
          units
          cost
        }
        return {
          units
          cost
        }
        ending {
          units
          cost
        }
      }
    }
  }
`;

export const GET_MONTLY_INVENTORY_REPORT = gql`
  query GetMonthlyInventoryReport(
    $warehouseId: ID
    $groupIds: [ID]
    $sectionIds: [ID]
    $levelSectionIds: [ID]
    $materialIds: [ID]
    $from: Date
    $to: Date
    $isHaveStock: Boolean
  ) {
    getMonthlyInventoryReport(
      warehouseId: $warehouseId
      groupIds: $groupIds
      sectionIds: $sectionIds
      levelSectionIds: $levelSectionIds
      materialIds: $materialIds
      from: $from
      to: $to
      isHaveStock: $isHaveStock
    ) {
      groupKhName
      groupEnName
      listMaterialsDesc {
        materialKhName
        materialEnName
        unitKhName
        unitEnName
        sizeKhName
        sizeEnName
        beginning {
          cost
          costPerUnit
          units
        }
        purchaseIn {
          costPerUnit
          units
          cost
        }
        averageCost
        issues {
          units
          cost
        }
        return {
          costPerUnit
          units
          cost
        }
        ending {
          units
          cost
        }
      }
      beginningUnit
      beginningcost
      purchaseUnit
      purchaseTotalCost
      issuesUnit
      issuesCost
      returnUnit
      returnCost
      endingUnit
      endingCost
    }
  }
`;

export const GET_DAILY_UNIFORM_REPORT = gql`
  query GetProvideMaterialForStudentReport(
    $warehouseIds: [ID]
    $materialIds: [ID]
    $unitIds: [ID]
    $from: Date
    $to: Date
    $studentId: ID
    $academicYearIds: [ID]
    $classIds: [ID]
    $gradeIds: [ID]
  ) {
    getProvideMaterialForStudentReport(
      warehouseIds: $warehouseIds
      materialIds: $materialIds
      unitIds: $unitIds
      from: $from
      to: $to
      studentId: $studentId
      academicYearIds: $academicYearIds
      classIds: $classIds
      gradeIds: $gradeIds
    ) {
      _id
      qty
      sellQty
      listMaterialUnitId {
        materialId {
          materialKhName
          materialEnName
        }
        unitId {
          unitEnName
          unitKhName
        }
      }
      studentBookId {
        warehouseId {
          warehouseName
        }
        studentId {
          englishName
          firstName
          lastName
        }
        enrollmentId {
          classId {
            className
            gradeId {
              gradeName
            }
          }
        }
        receiveBy
      }
    }
  }
`;

export const GET_RENT_MATERIAL_REPORT = gql`
  query GetRentMaterialReport(
    $warehouseIds: [ID]
    $materialIds: [ID]
    $listMaterialUnitIds: [ID]
    $from: Date
    $to: Date
    $studentId: ID
    $unitIds: [ID]
  ) {
    getRentMaterialReport(
      warehouseIds: $warehouseIds
      materialIds: $materialIds
      listMaterialUnitIds: $listMaterialUnitIds
      from: $from
      to: $to
      studentId: $studentId
      unitIds: $unitIds
    ) {
      _id
      condition
      dueDate
      warehouseId {
        warehouseName
      }
      qty
      listMaterialUnitId {
        materialId {
          isbm
          materialKhName
          materialEnName
        }
        unitId {
          unitKhName
          unitEnName
        }
      }
      rentMaterialId {
        studentId {
          _id
          firstName
          englishName
          lastName
        }
        dateTime
        rentBy
      }
    }
  }
`;

export const GET_ADJUST_OUT_REPORT = gql`
  query GetAdjustOutReport(
    $warehouseIds: [ID]
    $materialIds: [ID]
    $listMaterialUnitIds: [ID]
    $from: Date
    $to: Date
    $reasons: [ADJUST_OUT_REASON]
  ) {
    getAdjustOutReport(
      warehouseIds: $warehouseIds
      materialIds: $materialIds
      listMaterialUnitIds: $listMaterialUnitIds
      from: $from
      to: $to
      reasons: $reasons
    ) {
      _id
      listMaterialUnitId {
        materialId {
          materialEnName
          materialKhName
          isbm
        }
        barcode
        unitId {
          unitKhName
          unitEnName
        }
      }
      qty
      qtyInUnit
      adjustOutId {
        warehouseId {
          warehouseName
        }
        reason
        createdBy {
          mainUserId {
            latinName
            firstName
            lastName
          }
        }
        createdAt
      }
    }
  }
`;

export const GET_ADJUST_IN_REPORT = gql`
  query GetAdjustInReport(
    $warehouseIds: [ID]
    $materialIds: [ID]
    $listMaterialUnitIds: [ID]
    $supplierIds: [ID]
    $from: Date
    $to: Date
    $reasons: [ADJUST_IN_REASON]
  ) {
    getAdjustInReport(
      warehouseIds: $warehouseIds
      materialIds: $materialIds
      listMaterialUnitIds: $listMaterialUnitIds
      supplierIds: $supplierIds
      from: $from
      to: $to
      reasons: $reasons
    ) {
      _id
      qty
      unitPrice
      qtyInUnit
      unitPriceInUnit
      listMaterialUnitId {
        unitId {
          unitKhName
          unitEnName
        }
        materialId {
          smallUnitId {
            unitEnName
            unitKhName
          }
          materialKhName
          materialEnName
        }
        barcode
      }
      adjustInId {
        createdAt
        reason
        warehouseId {
          warehouseName
        }
        supplierId {
          _id
          name
        }
        createdBy {
          mainUserId {
            lastName
            latinName
            firstName
          }
        }
      }
    }
  }
`;
